export default {
  brewery: 'sideProjectFarmClub',
  info_url: 'http://landing.tavour.com/SideProjectFarmClub/',
  title: {
    in_progress: '',
    success: 'You Joined The Side Project Farm Club! ',
    subtext: 'Join The Side Project Farm Club. ',
    sub_subtext: 'The club is a quarterly subscription that delivers our beer directly to your door. ' +
      'Every three months, you’ll receive a six-bottle package featuring our oak-aged Saisons, ' +
      'Missouri Wild Ales and one guaranteed bottle of a Stout or Barleywine. ' +
      'It’s a convenient way to get the beers you love to share, ' +
      'delivered straight to your door.',
  },
  review: {
    summary: [
      'You are joining The Side Project Farm Club. ',
      'By signing up your card will be automatically charged $249 every three months (shipping included). ' +
      'Each shipment will contain a total of 6 bottles. ' +
      'You will have the option to opt out by emailing support@tavour.com. ' +
      'You will receive a notification when your box has been charged and shipped. ',
    ],
    button_text: 'Join The Side Project Farm Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/sideProjectFarmClub.js